"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatFormCommodityData = exports.formatCommodityData = void 0;
// 处理活动配置数据解析
const formatCommodityData = commodityObject => {
  let isConnect = false;
  let hasNoModel = false;
  let event = '';
  let commodity = '';
  let eventType = '';
  if (commodityObject) {
    let obj = JSON.parse(commodityObject);
    isConnect = obj.isConnect || false;
    hasNoModel = obj.hasNoModel || false;
    event = obj.event || '';
    eventType = obj.eventType || '';
    commodity = obj.commodity || '';
  }
  return {
    hasNoModel,
    isConnect,
    event,
    eventType,
    commodity
  };
};

// 处理表单资源配置数据解析
exports.formatCommodityData = formatCommodityData;
const formatFormCommodityData = commodityObject => {
  let needLogin = false;
  let event = '';
  let commodity = '';
  if (commodityObject) {
    let obj = JSON.parse(commodityObject);
    needLogin = obj.needLogin || false;
    event = obj.event || '';
    commodity = obj.commodity || '';
  }
  return {
    needLogin,
    event,
    commodity
  };
};
exports.formatFormCommodityData = formatFormCommodityData;